// ContactUsController
app.controller('ContactUsController', ['$scope',
    function($scope) {
        // Init 
        $scope.init = async function() {
            $scope.showPageLoader();
            await $scope.fetchAdviserSiteDetails();
            $scope.hidePageLoader();
        }
      
    }
]);